export const tenant = {
  not_found: "Tenant not found",
};

export const forbidden = {
  title: "Access denied",
  message:
    "You do not have permission to access any resource. Please contact your administrator.",
};

export const auth = {
  invalidCreds: "Invalid credentials",
};

export const common = {
  fields: {
    createdAt: "Created at",
    updatedAt: "Updated at",
  },
  audit: {
    button: "Audit",
    title: "Audit History",
    close: "Close",
    details: "Audit Details",
    dateTime: "Date and Time",
    user: "User",
    action: "Action",
    changes: "Changes Made",
    additionalInfo: "Additional Information",
    noChanges: "No field changes recorded for this action.",
    before: "Before",
    after: "After",
    yes: "Yes",
    no: "No",
    relatedResource: "Related Resource",
    relatedChange: "Related Change",
    metadata: {
      ip: "IP Address",
      userAgent: "Browser",
      userName: "User Name",
      userEmail: "User Email",
      changedBy: "Changed By",
      changedForUserId: "Changed For User",
      passwordChanged: "Password Changed",
      statusChanged: "Status Changed",
    },
  },
};

export const menu = {
  hr: "Human Resources",
  registrations: "Registrations",
  bi: "Business Intelligence",
  chat: "Support",
};

export const citySearch = {
  label: "City",
  placeholder: "Type to search for a city...",
  minChars: "Type at least 1 character to search",
  noResults: "No cities found",
};

export const validation = {
  phone: {
    invalid: "Invalid phone number",
  },
};

export const schedule = {
  timezone: "Timezone",
  start: "Start",
  end: "End",
  days: {
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
  },
};

export const hr = {
  fields: {
    name: "Name",
    role: "Role",
    requester: "Requester",
    openDate: "Open Date",
    closeDate: "Close Date",
    resumeSource: "Resume Source",
    campaign: "Campaign",
    price: "Price",
    candidateName: "Candidate Name",
    email: "Email",
    phone: "Phone",
    resumeUrl: "Resume URL",
    status: "Status",
    interviewDate: "Interview Date",
    notes: "Notes",
  },
  status: {
    CREATED: "Created",
    CONNECTED: "Connected",
    SCHEDULED: "Scheduled",
    INTERVIEWED: "Interviewed",
    HIRED: "Hired",
  },
  behavioralProfile: {
    ANALYTICAL: "Analytical",
    DRIVER: "Driver",
    AMIABLE: "Amiable",
    EXPRESSIVE: "Expressive",
  },
};
